import { render } from "./Logement.vue?vue&type=template&id=597829ee"
import script from "./Logement.vue?vue&type=script&lang=js"
export * from "./Logement.vue?vue&type=script&lang=js"

import "./Logement.vue?vue&type=style&index=0&id=597829ee&lang=less"
script.render = render

export default script